<app-page-content>
<app-doenkids-menu-bar menuBar [loading]="isSearching$ | async">
  <div left>
    <app-activity-search-bar [query]="currentSearchParams?.query" (searched)="doSearch($event)"></app-activity-search-bar>
  </div>
  <div right>
  </div>
</app-doenkids-menu-bar>
<div content class="page-container" #pageContainer>
  <app-split-page
    #splitPage
    [leftLabel]="'media_tags.tab.search_filters' | translate"
    [rightLabel]="'media_tags.tab.results' | translate"
    [activeTab]="1"
    [leftWidth]="30"
    [scrollEventsRight]="true"
    [hide]="(hideAggregations$ | async)"
    sideToHide="left"
    whatToHide="side"
    (scroll)="onScroll($event)"
    (scrollEndRight)="onScrollEnd($event)"
    (selectedTabChange)="tabChange($event)"
    parentSelectorToListenForRightScroll="#sidenav-content"
    >
    <ng-template #left>
      @if ((aggregations$ | async)) {
        <div class="aggregations">
          <app-search-aggregations [aggregationLabels]="(aggregationLabels$ | async)" translationPrefix="media_tags"
            [aggregationData]="(aggregations$ | async)" [formControl]="aggregationControl">
          </app-search-aggregations>
        </div>
      }
    </ng-template>
    <ng-template #right>
      <div class="results-panel">
        <div class="results-header" #resultsHeader>
          <div class="results-header-wrapper" [class.hasFilters]="(containsAggregations$ | async)">
            <mat-toolbar class="mat-toolbar-doenkids">
              <button mat-icon-button>
                @if (!( hideAggregations$ | async )) {
                  <mat-icon>chevron_left</mat-icon>
                }
                @if ((hideAggregations$ | async)) {
                  <mat-icon>chevron_right</mat-icon>
                }
              </button>
              @if ((mediaSearchMetadata$ | async); as metaData) {
                <div class="result-amount">
                  @if (metaData?.total > 0) {
                    <span>
                      <span [innerHTML]="'media_tags.results_found' | translate: {resultCount: metaData?.total}"></span>
                      &nbsp;
                      @if (metaData?.took >= 0) {
                        <span
                      [innerHTML]="'media_tags.search_duration' | translate: {
                        duration: metaData?.took / 1000  | i18n_number | async
                      }"
                          >
                        </span>
                      }
                      <br>
                      </span>
                    }
                    @for (suggestion of (searchSuggestions$ | async); track suggestion) {
                      <span class="did-you-mean">
                        @if (suggestion.options && suggestion.options.length > 0) {
                          <span>{{ 'media_tags.suggestions' | translate }}</span>
                          @for (option of suggestion.options; track option) {
                            <a href="#"  [innerHTML]="option.highlighted"></a>
                          }
                          <span>?</span>
                        }
                      </span>
                    }
                  </div>
                }
                <div class="spacer"></div>
              </mat-toolbar>
              @if ((containsAggregations$ | async)) {
                <mat-toolbar class="mat-toolbar-doenkids mat-toolbar-chips">
                  <app-search-chips [aggregationLabels]="(aggregationLabels$ | async)" (onRemoveAll)="removeAllFilters()" (onRemove)="removeFilter($event)"
                    [aggregationData]="(aggregations$ | async)" [selection]="aggregationControl.value" [storageKey]="mediaSearchStorageKey">
                  </app-search-chips>
                </mat-toolbar>
              }
            </div>
          </div>

          <div class="search-results">
            @if ((searchResults$ | async); as results) {
              <div class="body-container animated fadeIn">
                @if (results.length > 0) {
                  <ngx-masonry
                    [options]="{ gutter: 25, transitionDuration: '0s', fitWidth: true, horizontalOrder: true }">
                    @for (mediaItem of results; track mediaItem) {
                      <ngxMasonryItem [id]="'media' + mediaItem?.uuid" class="masonry-item">
                        @if ((allowedToEdit$ | async)) {
                          <button
                            class="media-tag-menu"
                            mat-icon-button
                            [matMenuTriggerFor]="menu"
                            [attr.aria-label]="'media_tags.options.label' | translate"
                            >
                            <mat-icon>more_vert</mat-icon>
                          </button>
                        }
                        <mat-menu #menu="matMenu">
                          <button (click)="openTagDialog(mediaItem)" mat-menu-item>
                            <mat-icon>remove_red_eye</mat-icon>
                            <span>{{ 'media_tags.option.show' | translate }}</span>
                          </button>
                          @if ((isAdmin$ | async) || (mediaItem.organization_unit_id.length === 1 && mediaItem.organization_unit_id[0] !== 1 && (userWritePermissionsOuIds$ | async).includes(mediaItem.organization_unit_id[0]))) {
                            <button (click)="deleteMediaItem(mediaItem)" mat-menu-item>
                              <mat-icon>close</mat-icon>
                              <span>{{ 'media_tags.option.archive' | translate }}</span>
                            </button>
                          }
                        </mat-menu>
                        <mat-card appearance="outlined" class="media-card" (click)="openTagDialog(mediaItem)">
                          <div class="image-container">
                            <app-doenkids-image (loaded)="imageLoaded()" [mediaItem]="{ uuid: mediaItem.uuid , description: '' }"></app-doenkids-image>
                          </div>
                          <div class="text-container">
                            @if (mediaItem.media_tags) {
                              {{ mediaItem.media_tags.join(',') }}
                            }
                            @if (!mediaItem.media_tags) {
                              <span class="no-tags">
                                {{ 'media_tags.no_tags_yet' | translate }}
                              </span>
                            }
                          </div>
                        </mat-card>
                      </ngxMasonryItem>
                    }
                  </ngx-masonry>
                }
              </div>
              @if ((searchResults$ | async).length === 0) {
                <div>
                  {{ 'media_tags.no_results' | translate }}
                </div>
              }
            }
          </div>
        </div>
      </ng-template>
    </app-split-page>
  </div>
</app-page-content>
